import sample from './sample'

export default { sample }
/**
 * @使用方式
 * this.$api.sample.postForm(...)
 */
